import { createFileRoute, redirect } from "@tanstack/react-router";

// Quyết định 0096 câu 7b: "Hướng dẫn concept" gộp vào trang Concept & Trang
// phục thành thẻ "Hướng dẫn chụp". Đường dẫn cũ giữ lại làm cửa chuyển hướng
// cho dấu trang / link đã gửi trong Zalo nội bộ. replace:true để nút Quay lại
// không bật người dùng vào vòng /concept-guides → /costumes → /concept-guides.
export const Route = createFileRoute("/_app/concept-guides")({
  beforeLoad: () => {
    throw redirect({ to: "/costumes", search: { tab: "guides" }, replace: true });
  },
});
